import axios from 'axios'
import store from '../store'
import { Message, Loading } from 'element-ui'
import { getToken } from '@/utils/auth' // getToken from cookie
const ConfigBaseURL = '' //默认路径，这里也可以使用env来判断np环境 process.env.BASE_API
let loadingInstance = null //这里是loading
let _this = this;
//使用create方法创建axios实例
export const Service = axios.create({
  // timeout: 7000, // 请求超时时间
  baseURL: ConfigBaseURL
})
// 添加请求拦截器
Service.interceptors.request.use(config => {
  // console.log(config)
  let token = getToken();
  let hasToken = token != 'undefined' && token != undefined && token !=null && token != '';
  config.headers.token = hasToken ? token : ''
  loadingInstance = Loading.service({
    lock: true,
    text: 'loading...'
  })
  return config
})
// 添加响应拦截器
Service.interceptors.response.use(response => {
  // console.log(response)
  loadingInstance.close()
  if(response.data.code == 4004 || response.data.code == 4007 || response.data.code == 4062){
    store.dispatch('user/logout').then(() => {
      _this.$router.push({path: '/login'})
    });
  }
  return response.data
}, error => {
  // console.log('TCL: error', error)
  // store.dispatch('user/logout').then(() => {
  //   _this.$router.push({path: '/login'})
  // });
  const msg = error.message !== undefined ? error.message : ''
  Message({
    message: '请求错误' + msg,
    type: 'error',
    duration: 3 * 1000
  })
  loadingInstance.close()
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/utils/Service.js